"use client"

import Link, { useLinkStatus } from "next/link"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@shared/ui"

const menuItemVariants = cva(
  "flex h-[34px] px-2 items-center gap-1.5 shrink-0 self-stretch",
  {
    variants: {
      variant: {
        default: "",
        active: "bg-[#2353B4] rounded-[6px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const iconVariants = cva("text-[14px]", {
  variants: {
    variant: {
      default: "text-[#A5A6F6]",
      active: "text-[#EDEEF1]",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})

export interface MenuItemProps extends VariantProps<typeof menuItemVariants> {
  icon: any
  text: string
  href: string
  className?: string
}

const LinkLoadingIndicator = () => {
  const { pending } = useLinkStatus()
  return pending ? (
    <div className="ml-1.5 size-3 animate-spin rounded-full border-2 border-[#A5A6F6] border-t-transparent" />
  ) : null
}

export const MenuItem = ({
  icon,
  text,
  href,
  variant,
  className,
}: MenuItemProps) => {
  return (
    <Link href={href} className={cn(menuItemVariants({ variant, className }))}>
      <FontAwesomeIcon icon={icon} className={cn(iconVariants({ variant }))} />
      <span className="text-[14px] font-semibold leading-[18px] text-[#EDEEF1]">
        {text}
      </span>
      <LinkLoadingIndicator />
    </Link>
  )
}
